import { createContext, useContext } from 'react';

export type SelectionContextValue = {
  adSelectedIds: Set<number>;
  setAdSelectedIds: React.Dispatch<React.SetStateAction<Set<number>>>;
};

export const SelectionContext = createContext<SelectionContextValue | null>(null);

export function useSelection(): SelectionContextValue {
  const ctx = useContext(SelectionContext);
  if (!ctx) throw new Error('useSelection must be used within a SelectionContext.Provider');
  return ctx;
}
